import './style.css';
import React, { useEffect, useState } from 'react'
import { http_request } from '../../../../libs/connection';
import { BASE_ROUTE, ROOT_ADDR, SESSION_EXPIRED_CODE } from '../../../../config';
import { Table } from 'react-bootstrap';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { createTimeString, getOrderStatus } from '../../../../libs/lib';
import Progress from '../../../../components/progress';
import QRCode from 'react-qr-code';


function OutsourcingShipDetail() {
    const url_params = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const [is_loading, setLoadingStatus] = useState(false);
    const { pathname } = location;
    const { fd_no } = url_params;
    const [order, setOrder] = useState({});
    const [status_message, setStatusMessage] = useState('读取中');
    const [sign_image, setSignImage] = useState(null);

    useEffect(()=>{
        setStatusMessage('读取中');
    }, [pathname]);

    useEffect(()=>{
        loadOrder();
    }, [pathname, fd_no]);


    function loadOrder(){
        if(!fd_no) return;
        let params = {
            fd_no
        };
        setLoadingStatus(true);
        http_request('/outsourcingShipOrder/get', 'POST', params).then(res=>{
            setLoadingStatus(false);
            if(res.success){
                let order = res.data.outsourcing_ship_order;
                
                if(!order.fd_no){
                    setStatusMessage('无效的出货单号');
                    return;
                }
                setOrder(order);
                if(order.sign_url){
                    let url = order.sign_url.replace(ROOT_ADDR, '');
                    http_request(url, 'GET', {}, true, false).then(r=>{
                        r.text().then(res=>{
                            setSignImage(res);
                        })
                    });
                }
            }else if(res.message === SESSION_EXPIRED_CODE){
                navigate(`${BASE_ROUTE}/logout`);
            }else{
                setStatusMessage(res.message);
            }
        })
    }
    return (
        <div id="page-outsourcing-ship-detail" className='page'>
            <Progress show={is_loading} varient="primary" />
            <div className={`bg-white ${ order.fd_no ? 'd-block ' : 'd-flex' } flex-grow-1 flex-column content`}>
                {
                    sign_image && <div className='d-flex align-items-center justify-content-center py-3 border-bottom'>
                        <img id="sign" src={sign_image}></img>
                    </div>
                }
                {
                    order.fd_no ? <div className={`overflow-auto table-container`}>
                        <Order 
                            order={order}
                            setOrder={setOrder}
                        />
                    </div> : <StatusTip message={status_message} />
                }
            </div>
        </div>
    )
}

function Order(props){
    let { order } = props;
    function mapOsType(){
        switch(order.outsourcing_ship_order_detail.os_type){
            case 'O': return '正常收货';
            case 'G': return '无偿超收';
            default: return '';
        }
    }
    return <div className='container overflow-auto h-100'>
        <div className='container p-0 overflow-auto'>
            <div className='d-flex align-items-center justify-content-center my-5'>
                <QRCode
                    size={256}
                    className='qr-code mb-2'
                    value={`${ROOT_ADDR}/erp/outsourcing/ship/detail/${order.fd_no}`}
                />
            </div>
            <Table className='mb-3'>
                <tbody>
                    <tr>
                        <td className='fw-bold'>建立日期</td>
                        <td>{createTimeString('y-m-d', order.date)}</td>
                    </tr>
                    <tr>
                        <td className='fw-bold'>签收日期</td>
                        <td>{order.fd_date ? createTimeString('y-m-d', order.fd_date) : '--'}</td>
                    </tr>
                    <tr>
                        <td className='fw-bold'>签收状态</td>
                        <td>[{getOrderStatus(order.temp_no, order.result)}]{order.temp_no ? '已签收' : (order.result ||'').replace(/^\d+\./, '')}</td>
                    </tr>
                    <tr>
                        <td className='fw-bold'>外包单号</td>
                        <td>{order.os_odno}</td>
                    </tr>
                    <tr>
                        <td className='fw-bold'>厂商代号</td>
                        <td>{order.cu_no}</td>
                    </tr>
                    <tr>
                        <td className='fw-bold'>经办代号</td>
                        <td>{order.cu_sale}</td>
                    </tr>
                    <tr>
                        <td className='fw-bold'>厂商出货单号</td>
                        <td>{order.company_fd_no}</td>
                    </tr>
                    <tr>
                        <td className='fw-bold'>备註</td>
                        <td>{order.qc_remk}</td>
                    </tr>
                </tbody>
            </Table>
        </div>
        <div className='border-bottom mb-3 pb-3 px-2' style={{ fontSize: 14 }}>
            <ul className=''>
                <li>{order.outsourcing_ship_order_detail.ch_seq}</li>
                <li>{order.outsourcing_ship_order_detail.el_no}</li>
                <li>出货数量：{order.outsourcing_ship_order_detail.qc_qty2}</li>
                <li>备註：{order.outsourcing_ship_order_detail.os_remk}</li>
                <li>{mapOsType()}</li>
            </ul>
        </div>
    </div>;
}

function StatusTip(props){
    let { message } = props;
    return <div className='bg-light d-flex align-items-center justify-content-center flex-grow-1'>
        <span className='text-secondary '>{message}</span>
    </div>
}

export default OutsourcingShipDetail;
